var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"section bg-gray-4"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"w-layout-grid grid-quarters cards-grid"},_vm._l((_vm.posts),function(post){return _c('SocialMediaPost',{key:post.post_title,attrs:{"post":post,"showTitle":_vm.ShowTitle}})}),1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }